import * as React from 'react'
import * as Tgcc from '../tgccGlobal'
import {browserHistory} from 'react-router'
import {connect} from 'react-redux'
import * as Request from '../tgccRequest'
import Radium, { StyleRoot } from 'radium'
import { MajorAccountsHdr } from './MajorAccountsHdr';

const styles: { [key: string]: React.CSSProperties } = {
    // Container Styles
    container: {
        minHeight: '100vh', // Ensure it covers the full viewport height
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        background: 'linear-gradient(to bottom, #f7f8fa, #e3e6ea)', // Soft gradient background
        '@media (max-width: 768px)': {
            marginTop: '10vh',
        }
    },
    registerBox: {
        marginTop: '20px',
        width: '90%',
        maxWidth: '550px',
        padding: '30px',
        backgroundColor: 'rgba(255, 255, 255, 0.9)', // Slight transparency for blend effect
        fontFamily: 'CenturyGothic',
        textTransform: 'uppercase',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        borderRadius: '10px',
        boxShadow: '0 6px 12px rgba(0, 0, 0, 0.1)', // Enhanced shadow
        border: '1px solid #dcdcdc', // Subtle border
        boxSizing: 'border-box', // Ensure padding doesn't affect width
        '@media (max-width: 768px)': {
            width: '95%',
        },
    },

    // Row Style
    rowStyle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        gap: '10px', // Add consistent spacing between elements
        marginBottom: '20px', // Add spacing between rows
        '@media (max-width: 768px)': {
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
        },
    },
    // Label Style
    lblStyle: {
        color: '#333333', // Use a darker color for better contrast
        fontSize: '16px',
        fontWeight: 'bold', // Make the labels stand out
        flex: '0 0 180px', // Fixed width for desktop
        textAlign: 'left', // Align text to the left for a natural look
        marginRight: '10px',
        fontFamily: 'Lulo',
        lineHeight: '1.5', // Ensure labels are aligned with inputs
        '@media (max-width: 768px)': {
            flex: '1 1 100%',
            marginBottom: '5px',
        },
    },

    // Input Fields
    inputStyle: {
        backgroundColor: '#ffffff',
        border: '1px solid #cccccc',
        borderRadius: '4px',
        height: '40px', // Slightly taller for better UX
        lineHeight: '1.5',
        padding: '0 10px',
        flex: '1 1 auto',
        fontSize: '16px',
        color: '#333333',
        boxShadow: 'inset 0 1px 2px rgba(0, 0, 0, 0.1)', // Subtle inset shadow
        width: '100%', // Ensure inputs adapt to container width
        '@media (max-width: 768px)': {
            width: '100%', // Full width on smaller screens
            marginBottom: '10px',
        },
    },

    // Checkbox Input
    checkboxInput: {
        width: '20px',
        height: '20px',
        marginRight: '10px', // Add space between checkbox and label
        verticalAlign: 'middle', // Align checkbox with the middle of the label
    },

    // Button
    submitBtn: {
        border: '2px solid transparent',
        backgroundColor: '#3366cc', // Blue button
        height: '48px',
        lineHeight: '45px',
        fontSize: '15px',
        padding: '0 30px',
        textAlign: 'center',
        textTransform: 'uppercase',
        color: 'white',
        alignSelf: 'center',
        cursor: 'pointer',
        width: 'auto',
        fontFamily: 'Lulo',
        borderRadius: '4px',
        marginTop: '20px',
        ':hover': {
            backgroundColor: '#2b5cbf',
        },
        '@media (max-width: 768px)': {
            width: '100%', // Full width on smaller screens
        },
    },

    // Headers
    dashText: {
        display: 'inline-block',
        letterSpacing: '0.3em',
        fontSize: '28px', // Slightly larger
        fontFamily: 'Lulo',
        color: '#444444',
    },

    createAcc: {
        textAlign: 'center',
    },

    // Marketing Opt-In Section
    marketingOptInSection: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between', // Spread content horizontally
        flexWrap: 'nowrap',
        marginTop: '20px',
        '@media (max-width: 768px)': {
            flexWrap: 'wrap',
            justifyContent: 'center',
        },
    },
    marketingOptInLabel: {
        fontSize: '14px',
        lineHeight: '1.5',
        color: '#333333',
        flex: '1 1 auto',
        maxWidth: 'calc(100% - 34px)', // Adjust for checkbox space
    },
    marketingOptInCheckbox: {
        width: '20px',
        height: '20px',
        flexShrink: 0,
    },
    errorMessage: {
        color: 'red',
        fontSize: '14px',
        fontWeight: 'bold',
        textAlign: 'center',
        marginBottom: '10px',
    },
};




let nameStyle = Object.assign({}, styles.inputStyle, { width: '137px', textTransform: 'capitalize', '@media(max-width: 320px)': { width: '110px' } });
let passwordStyle = Object.assign({}, styles.inputStyle, { width: '115px', '@media(max-width: 320px)': { width: '98px' } });
let emailStyle = Object.assign({}, styles.inputStyle, { width: '278px', '@media(max-width: 320px)': { width: '210px' } });
let addressStyle = Object.assign({}, styles.inputStyle, { width: '300px' });
let orgStyle = Object.assign({}, styles.inputStyle, { width: '300px' });
let schOrBusStyle = Object.assign({}, styles.inputStyle, { width: '300px' });


class _MajorAccountsRegister extends React.Component<Tgcc.BaseProps, any> {
    state: any = {
        error: "",
        email: "",
        
        firstName: "",
        lastName: "",
        isWaiting: false,
        Schools:null,
        school:null,
        isCollegiate:false,
        org: null,
        address: null,
        city:null,
        St:null,
        zip:null,
        phone:null,
        group:null,
        buyer:"No",
        isBuyer:false,
        smsAllowed:true,
        studentGroup: null,
        type:"Corporate",
        marketingOptIn: true,
        showOtp: false,
        otpCode: "",
        otpError: "",
        isSendingOtp: false,
        resendAfter: 60,
        resendCountdown: 0,
        isResending: false,
    };

    componentWillMount() {
        this.clearState();
        Request.getSchools((schools : string[]) => this.SchoolsLoaded(schools));
        console.log(this.state.type);
    }
    componentDidMount(){
        var tag = document.getElementById('register');
        tag.scrollIntoView(false);
    }

    componentWillUnmount() {
        // Clear the OTP timer to prevent memory leaks
        clearInterval((this as any)._otpTimer);
    }
    
    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }

    SchoolsLoaded(schools : string[]) {
        this.setState({Schools: schools});
    }
    clearState = () => {
        this.setState({Schools: null,school:null,isCollegiate:false,Orgs:null,org:null});       
    }

    failedLogin = (err: any) => {
        this.setState({error: "registration succeeded, but login failed", isWaiting: false});
    }
    

    successfulRegistration = (userData: Tgcc.UserInfo) => {
        // This handler is now used after backend returns token+user
        try {
            const anyData: any = userData as any;
            if (anyData && (anyData.token || anyData.accessToken)) {
                const loginData = anyData;
                Tgcc.successfulMajorAccountsLogin(this.props.dispatch, loginData);
                // Create ghost proof with new login
                let ghostProofData = new Tgcc.UserInfo();
                ghostProofData.email = this.state.email;
                Request.createGhostProof(ghostProofData, loginData,
                    (proof) => { },
                    (error) => { console.error("Failed to create ghost proof", error); }
                );
                this.setState(prev => ({ ...prev, isWaiting: false, showOtp: false }));
                return;
            }
        } catch {}
        // Fallback: just set profile
        this.props.dispatch({ type: Tgcc.StateAction.SetUserInfo, payload: userData });
        this.setState(prev => ({ ...prev, isWaiting: false, showOtp: false }));
    }
    
    getSchools() {
        var schools = new Array();
        for (var i in this.state.Schools) {
            var cat: string = this.state.Schools[i];
            schools.push(
                <option key={i} value={cat}>{cat}</option>
            )
        };
        return schools;
    }

    failedRegistration = (err: string) => {
        this.setState({error: err, isWaiting: false});
    }

    doRegistration = () => {
        
        if(!this.state.firstName || !this.state.firstName.trim())
            this.setState({error: 'First Name cannot be blank', isWaiting: false});
        else if(!this.state.lastName || !this.state.lastName.trim())
            this.setState({error: 'Last Name cannot be blank', isWaiting: false});
        else if(!this.state.email || !this.state.email.trim())
            this.setState({error: 'Email cannot be blank', isWaiting: false});
        else if(!this.state.address || !this.state.address.trim())
            this.setState({error: 'Address cannot be blank', isWaiting: false});
        else if(!this.state.city || !this.state.city.trim())
            this.setState({error: 'City cannot be blank', isWaiting: false});
        else if(!this.state.St || !this.state.St.trim())
            this.setState({error: 'State cannot be blank', isWaiting: false});
        else if(!this.state.zip || !this.state.zip.trim())
            this.setState({error: 'Zip code cannot be blank', isWaiting: false});
        else if(!this.state.phone || !this.state.phone.trim())
            this.setState({error: 'Phone cannot be blank', isWaiting: false});
        else {
            // Request OTP then show modal
            if (!this.state.email || !this.state.email.trim()) {
                this.setState({ error: 'Email cannot be blank', isWaiting: false });
                return;
            }
            this.setState({ isWaiting: true, isSendingOtp: true, otpError: '' });
            Request.requestRegistrationOtp(
                this.state.email,
                (_res) => {
                    const wait = _res && _res.resendAfterSeconds ? _res.resendAfterSeconds : 60;
                    this.startResendCountdown(wait);
                    this.setState({ isWaiting: false, isSendingOtp: false, showOtp: true, resendAfter: wait });
                },
                (err: string) => this.setState({ error: err, isWaiting: false, isSendingOtp: false })
            );
        }
    }

    marketingOptInChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        this.setState({ marketingOptIn: evt.currentTarget.checked });
    };

    fnameChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        this.setState({firstName: evt.currentTarget.value});
    }
    lnameChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        this.setState({lastName: evt.currentTarget.value});
    }
    emailChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        this.setState({email: evt.currentTarget.value});
    }

    // passwordless: remove password handlers

    submitOtp = () => {
        if (!this.state.otpCode || this.state.otpCode.trim().length !== 6) {
            this.setState({ otpError: 'Enter the 6-digit code.' });
            return;
        }
        this.setState({ isWaiting: true, otpError: '' });
        var user = new Tgcc.UserInfo;
        user.email = this.state.email;
        user.firstName = this.state.firstName;
        user.lastName = this.state.lastName;
        user.schoolOrBusiness = this.state.school;
        user.studentGroup = this.state.studentGroup
        user.organization = this.state.org;
        user.address = this.state.address;
        user.city = this.state.city;
        user.state = this.state.St;
        user.zip = this.state.zip;
        user.phone = this.state.phone;
        user.smsAllowed = this.state.smsAllowed;
        user.group = this.state.group;
        user.buyer = this.state.buyer;
        user.type = this.state.type;         
        user.marketingOptIn = this.state.marketingOptIn;
        Request.registerUserPasswordless(
            user,
            this.state.otpCode,
            (data: any) => this.successfulRegistration(data as any),
            (err: string) => this.setState({ otpError: err, isWaiting: false })
        );
    }

    closeOtp = () => { this.setState({ showOtp: false }); }

    startResendCountdown = (seconds: number) => {
        this.setState({ resendCountdown: seconds });
        clearInterval((this as any)._otpTimer);
        ;(this as any)._otpTimer = setInterval(() => {
            this.setState((prev: any) => {
                const next = (prev.resendCountdown || 0) - 1;
                if (next <= 0) {
                    clearInterval((this as any)._otpTimer);
                    return { resendCountdown: 0 };
                }
                return { resendCountdown: next };
            });
        }, 1000);
    }

    resendOtp = () => {
        if ((this.state.resendCountdown || 0) > 0 || this.state.isResending) return;
        this.setState({ isResending: true, otpError: '' });
        Request.requestRegistrationOtp(
            this.state.email,
            (_res) => {
                const wait = _res && _res.resendAfterSeconds ? _res.resendAfterSeconds : 60;
                this.startResendCountdown(wait);
                this.setState({ isResending: false });
            },
            (err: string) => this.setState({ isResending: false, otpError: err })
        );
    }
    checkKeyPressed = (evt: React.KeyboardEvent<HTMLInputElement>) => {
        if(evt.key === 'Enter')
            this.doRegistration();
    }
    schoolChanged = (evt: React.FormEvent<HTMLSelectElement>) => {
        this.setState({school:evt.currentTarget.value})
    }
    companyChanged = (evt:React.FormEvent<HTMLInputElement>) => {
        this.setState({school:evt.currentTarget.value})
    }
    orgChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        this.setState({org:evt.currentTarget.value})
    }
    studentChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        this.setState({studentGroup:evt.currentTarget.value})
    }
    grpSizeChg = (evt: React.FormEvent<HTMLSelectElement>) => {
        this.setState({group:evt.currentTarget.value})
    }
    addressChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        this.setState({address:evt.currentTarget.value})
    }
    cityChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        this.setState({city:evt.currentTarget.value})
    }
    stateChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        this.setState({St:evt.currentTarget.value})
    }
    zipChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        this.setState({zip:evt.currentTarget.value})
    }
     phoneNumberChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        this.setState({phone:Tgcc.formatPhoneNumber(evt.currentTarget.value)});
    }
    smsAllowedChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        this.setState({smsAllowed: evt.currentTarget.checked});
    }
    buyerChanged = (evt:React.FormEvent<HTMLInputElement>) => {
        this.setState({isBuyer:evt.currentTarget.checked});
        if(evt.currentTarget.checked){
            this.setState({buyer:'Yes'});
        } else {
            this.setState({buyer:'No'});
        }
    }
    getDashHeader(){
        return (
            <div style={styles.createAcc} className="createAcct">
                <div style={styles.dashHdrLineR} className="hdrLines"></div>
                <h1 style={styles.dashText}>CREATE AN ACCOUNT</h1>
                <div style={styles.dashHdrLineL} className="hdrLines"></div>

            </div>
        )
    }
    openLogin = () =>{browserHistory.push(Tgcc.Routes.Login)}
    collegiateCheck(){
            return (<div>
                        <div style={styles.rowStyle}>
                            <div style={styles.lblStyle} className="registerLabels">School</div>
                                <select onChange={this.schoolChanged} name="school" style={styles.selectStyle} className="registerSelect">
                                    {this.getSchools()}
                                </select>
                        </div>
                        <div style={styles.rowStyle}>
                            <div style={styles.lblStyle} className="registerGroup">Student Group</div>
                                <input type='text' style={styles.orgStyle} onChange={this.studentChanged} name="studentGroup" placeholder="Wiffle Ball Club, Kappa Delta" onKeyPress={this.checkKeyPressed} />
                        </div>
                        <div style={styles.rowStyle}>
                            <div style={styles.lblStyle} className="registerLabels">Group Size</div>
                            <select onChange={this.grpSizeChg} name="group" style={styles.selectStyle}>
                                <option key={1} value={"1-23"}>1-23</option>
                                <option key={2} value="24-49">24-49</option>
                                <option key={3} value="50-99">50-99</option>
                                <option key={4} value="100-149">100-149</option>
                                <option key={5} value="150-299">150-299</option>
                                <option key={6} value="300+">300+</option>
                            </select>
                        </div>
                        <div style={styles.rowStyle}>
                            <div style={styles.lblStyle} className="collegiateCustomer">Are you the buyer?</div>
                            <input type="checkbox" className="checkboxStyle" style={styles.checkboxStyle} onChange={this.buyerChanged} name="buyer" checked={this.state.isBuyer}/>
                        </div>
                   </div>)
    }
    render() {
        const btnElement = this.state.isWaiting ? (
            Tgcc.workingGif
        ) : (
            <div style={styles.submitBtn} onClick={this.doRegistration}>
                Submit
            </div>
        );
    
        return (
            <div style={styles.container}>
                <div id="register"></div>
                <MajorAccountsHdr />
                <div style={styles.createAcc}>
                    <h1 style={styles.dashText}>CREATE A CORPORATE ACCOUNT</h1>
                </div>
                <div style={styles.registerBox}>
                    {/* Name Section */}
                    <div style={styles.rowStyle}>
                        <label style={styles.lblStyle}>Name</label>
                        <div style={{ flex: '1 1 auto', display: 'flex', gap: '10px' }}>
                            <input
                                autoFocus
                                type="text"
                                style={styles.inputStyle}
                                name="firstName"
                                onChange={this.fnameChanged}
                                placeholder="First Name"
                            />
                            <input
                                type="text"
                                style={styles.inputStyle}
                                name="lastName"
                                onChange={this.lnameChanged}
                                placeholder="Last Name"
                            />
                        </div>
                    </div>
    
                    {/* Business Section */}
                    <div style={styles.rowStyle}>
                        <label style={styles.lblStyle}>Business</label>
                        <input
                            type="text"
                            style={styles.inputStyle}
                            name="schoolOrBusiness"
                            onChange={this.companyChanged}
                            placeholder="CED, Riverside High School"
                        />
                    </div>
    
                    {/* Address Section */}
                    <div style={styles.rowStyle}>
                        <label style={styles.lblStyle}>Address</label>
                        <input
                            type="text"
                            style={styles.inputStyle}
                            name="address"
                            onChange={this.addressChanged}
                            placeholder="Street Address"
                        />
                    </div>
                    <div style={styles.rowStyle}>
                        <input
                            type="text"
                            style={{ ...styles.inputStyle, width: '60%' }}
                            name="city"
                            onChange={this.cityChanged}
                            placeholder="City"
                        />
                        <input
                            type="text"
                            style={{ ...styles.inputStyle, width: '15%' }}
                            name="state"
                            onChange={this.stateChanged}
                            placeholder="State"
                        />
                        <input
                            type="text"
                            style={{ ...styles.inputStyle, width: '25%' }}
                            name="zip"
                            onChange={this.zipChanged}
                            placeholder="Zip Code"
                        />
                    </div>
    
                    {/* Phone Section */}
                    <div style={styles.rowStyle}>
                        <label style={styles.lblStyle}>Phone#</label>
                        <input
                            type="text"
                            style={styles.inputStyle}
                            name="phone"
                            onChange={this.phoneNumberChanged}
                            placeholder="Phone Number"
                        />
                    </div>
    
                    {/* Receive SMS Notifications Section */}
                    <div style={styles.rowStyle}>
                        <label style={styles.lblStyle}>Receive Text Notifications?</label>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <input
                                type="checkbox"
                                style={styles.checkboxInput}
                                name="smsAllowed"
                                onChange={this.smsAllowedChanged}
                                checked={this.state.smsAllowed}
                            />
                            <span style={styles.marketingOptInLabel}>
                                Get order updates and important info via text. By checking this box, you agree to receive SMS messages from us. Msg & data rates may apply.
                            </span>
                        </div>
                    </div>

                    {/* Marketing Opt-In Section */}
                    <div style={styles.rowStyle}>
                        <label style={styles.lblStyle}>Marketing Opt-In</label>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <input
                                type="checkbox"
                                style={styles.checkboxInput}
                                name="marketingOptIn"
                                onChange={this.marketingOptInChanged}
                                checked={this.state.marketingOptIn}
                            />
                            <span style={styles.marketingOptInLabel}>
                                Get exclusive discounts, early access to sales, and the latest updates via text. By checking this box, you agree to receive promotional SMS messages from us. Msg & data rates may apply. View our{' '}
                                <a
                                    href={Tgcc.Routes.LegalPage}
                                    target="_blank"
                                    style={{ textDecoration: 'underline', color: '#3366cc' }}
                                >
                                    Privacy Policy and Terms
                                </a>.
                            </span>
                        </div>
                    </div>

                    {/* Email Section */}
                    <div style={styles.rowStyle}>
                        <label style={styles.lblStyle}>Email</label>
                        <input
                            type="email"
                            style={styles.inputStyle}
                            name="email"
                            onChange={this.emailChanged}
                            placeholder="Email Address"
                        />
                    </div>
    
                    {/* Passwordless: no password fields */}
                    {this.state.error && <div style={styles.errorMessage}>{this.state.error}</div>}
                    {/* Submit Button */}
                    {btnElement}
                </div>
                {this.state.showOtp && (
                    <div key="otpOverlay" style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}>
                        <div key="otpDialog" style={{ background: '#fff', padding: '24px', borderRadius: '12px', width: '90%', maxWidth: '500px', boxShadow: '0 16px 40px rgba(0,0,0,0.2)', position: 'relative' }}>
                            <div key="otpCloseX" onClick={this.closeOtp} style={{ position: 'absolute', right: 12, top: 10, cursor: 'pointer', fontSize: '20px', color: '#888' }}>×</div>
                            <h3 style={{ margin: '0 0 8px 0', fontFamily: 'Lulo', letterSpacing: '0.1em' }}>Verify your email</h3>
                            <div style={{ color: '#555', marginBottom: '16px', lineHeight: '20px' }}>
                                We sent a 6‑digit code to <strong>{(this.state.email || '').replace(/(.{2}).+(@)/, '$1***$2')}</strong>.
                                Enter it below to create your account. This code expires in 10 minutes.
                            </div>
                            <input type="text" maxLength={6} aria-label="6-digit verification code" style={{ ...styles.inputStyle, textAlign: 'center', letterSpacing: '8px', fontSize: '26px', fontFamily: 'monospace' }} value={this.state.otpCode} onChange={(e) => {
                                const v = (e.currentTarget && e.currentTarget.value) ? e.currentTarget.value : '';
                                this.setState({ otpCode: v.replace(/[^0-9]/g, '') });
                            }} onKeyPress={(e) => {
                                if (e.key === 'Enter' && this.state.otpCode && this.state.otpCode.length === 6) {
                                    this.submitOtp();
                                }
                            }} />
                            {this.state.otpError && <div style={styles.errorMessage}>{this.state.otpError}</div>}
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '12px', width: '100%' }}>
                                <div>
                                    <button key="otpResend" onClick={this.resendOtp} disabled={(this.state.resendCountdown || 0) > 0 || !!this.state.isResending} style={{ border: 'none', background: 'transparent', color: '#3366cc', cursor: ((this.state.resendCountdown || 0) > 0 || !!this.state.isResending) ? 'default' : 'pointer', textDecoration: 'underline' }}>
                                        {this.state.isResending ? 'Resending…' : (this.state.resendCountdown && this.state.resendCountdown > 0 ? `Resend in ${this.state.resendCountdown}s` : 'Resend code')}
                                    </button>
                                </div>
                                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                    <div key="otpCancel" style={{ ...styles.submitBtn, backgroundColor: '#777', whiteSpace: 'nowrap' }} onClick={this.closeOtp}>Cancel</div>
                                    <div key="otpVerify" style={{ ...styles.submitBtn, whiteSpace: 'nowrap', opacity: this.state.otpCode && this.state.otpCode.length === 6 ? 1 : 0.6, pointerEvents: this.state.otpCode && this.state.otpCode.length === 6 ? 'auto' : 'none' }} onClick={this.submitOtp}>Verify</div>
                                </div>
                            </div>
                            <div style={{ color: '#888', marginTop: '10px', fontSize: '12px' }}>Tip: You can paste the entire code. Numbers only.</div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
    
}

const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state };
};

export var MajorAccountsRegister = connect(mapStateToProps)(Radium(_MajorAccountsRegister));